import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {MbToastComponent} from './components/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MbToastComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Admin-Portal';
}
